import React from 'react';
import { StyleSheet, View } from 'react-native';

import { theme } from '@garnish/constants';
import { ShareIcon } from '../../ShareIcon';
import { HStack } from '../../Stack';
import { LineItemQuantity } from './LineItemQuantity';
import { LineItemFavoriteBtn } from './LineItemFavoriteBtn';
import { LineItemRemoveBtn } from './LineItemRemoveBtn';

// ────────────────────────────────────────────────────────────────────────────────

export const LineItemFooter = (props: ProductFooterProps) => {
  const {
    quantity = 0,
    onQuantityChange,
    isFavorite,
    isFetchingFavorite,
    shareBtnLabel,
    shareTooltipLabel,
    productId,
    removeBtnLabel,
    isDisabled,
    productSlug,
    onFavorite,
    onShare,
    onRemove,
  } = props;

  return (
    <View style={styles.wrapper}>
      <HStack itemStyle={styles.stackItem}>
        {quantity ? (
          <LineItemQuantity
            isDisabled={isDisabled}
            quantity={quantity}
            onQuantityChange={onQuantityChange}
            productSlug={productSlug}
          />
        ) : null}

        {onFavorite ? (
          <LineItemFavoriteBtn
            isActive={isFavorite}
            disabled={isFetchingFavorite}
            onPress={onFavorite}
          />
        ) : null}

        {onShare ? (
          <ShareIcon
            shareBtnLabel={shareBtnLabel}
            shareTooltipLabel={shareTooltipLabel}
            onShare={onShare}
          />
        ) : null}
      </HStack>

      {onRemove ? (
        <LineItemRemoveBtn
          productId={productId}
          accessibilityLabel={removeBtnLabel}
          disabled={isDisabled}
          testID={`sg-line-item-card-remove-${productSlug}`}
          onPress={onRemove}
        />
      ) : null}
    </View>
  );
};

// ─── STYLES ─────────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  wrapper: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingTop: theme.spacing['2'],
  },
  stackItem: {
    justifyContent: 'center',
  },
});

// ─── TYPES ──────────────────────────────────────────────────────────────────────

type ProductFooterProps = {
  readonly productId: string;
  readonly productSlug: string;
  readonly quantity?: number;
  readonly removeBtnLabel?: string;
  readonly shareTooltipLabel?: string;
  readonly shareBtnLabel?: string;
  readonly isFetchingFavorite?: boolean;
  readonly isFavorite?: boolean;
  readonly isDisabled?: boolean;
  readonly onRemove?: (productId: string) => void;
  readonly onShare?: () => void;
  readonly onFavorite?: () => void;
  readonly onQuantityChange?:
    | ((selectedQuantity: number) => void)
    | ((selectedQuantity: number) => Promise<void>);
};
